import { api, formatApiErrorDetail } from "./api";

export async function claimReward(auditId) {
  try {
    const { data } = await api.post(`/audits/${auditId}/claim-reward`);
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      body: e.response?.data,
      message: formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}

export const TIER_META = {
  silver: {
    label: "silver",
    accent: "#C0C0C0",
    accentSoft: "#808080",
    reward: 0,
  },
  gold: {
    label: "gold",
    accent: "#FFD700",
    accentSoft: "#B8860B",
    reward: 0,
  },
  master: {
    label: "master",
    accent: "#FFD700",
    accentSoft: "#B8860B",
    reward: 5,
  },
};
